<template>
  <div>
    <v-card>
        <v-card-title>
            <div>
                <div class="title">Login Account</div>
                <div v-if="!isNew" class="orange--text">
                    Leave Password blank if you do not want to change password
                </div>

            </div>
            
        </v-card-title>
        <v-card-text>
            <v-layout row v-if="isNew">
                <v-flex xs12>
                    <v-text-field label="Username" v-model="editUserData.accountInfo.username" type="text" 
                    :rules="[rules.required]"
                    ></v-text-field>
                </v-flex>
            </v-layout>
            <v-layout row>
                <v-flex xs12>
                    <v-text-field label="Password" v-model="editUserData.accountInfo.password" 
                        type="password" 
                        :rules="isNew?[rules.required]:[]"
                        hint="At least 6 characters with one upper case, one number"
                        persistent-hint
                        autocomplete="new-password"></v-text-field>
                        <!-- autocomplete="new-password" will prevent chrome populate password -->
                </v-flex>
            </v-layout>
            <v-layout row>
                <v-flex xs12>
                    <v-text-field label="Confirm Password" v-model="editUserData.accountInfo.confirmPassword" 
                    type="password" :rules="[comparePasswords, usernameNotEqualPassword]" ></v-text-field>
                </v-flex>
            </v-layout>

      </v-card-text>
    </v-card>
    <!-- {{editUserData}} -->
  </div>
</template>
<script>
export default {
    props: ['editUserData'],
    data () {
        return {
            rules: {
                required: v => !!v || "This field is required"
            },
        }
    },
    computed: {
        isNew () {
            return !this.editUserData.userId
        },
        comparePasswords () {
            return this.editUserData.accountInfo.password !== this.editUserData.accountInfo.confirmPassword ? 'Passwords do not match' : true
        },
        usernameNotEqualPassword() {
            return this.editUserData.accountInfo.username != this.editUserData.accountInfo.password? 
                true : "Username and Password cannot be same"
        },
       
    },
    watch: {
        // user (value) {
        //     if (value !== null && value !== undefined) {
        //         this.$router.push('/')
        //     }
        // },
        // 'editUserData.roles': {
        //     handler: function (newVal, oldVal) {
        //         // console.log('watch editUserData changed')
        //         // this.checkShowLoginSection()
        //     },
        //     deep: true
        // }
    },
    methods: {
        // ...mapActions('adminUser', [
        //     'getAllRoles'
        // ]),
        // checkShowLoginSection () {
        //     // this.showLoginSection = (this.editUserData.roles !== undefined && this.editUserData.roles.length > 0)
        // },
    },
    created: async function () {
        // this.roles = await this.getAllRoles();
    },
}
</script>